<template>
  <div class="lxm-contact-tag">
    <!--<lxm-nav :title="'王小华'"></lxm-nav>-->

    <div class="page">
      <div class="lxm-contact-tag__tag">
        <lxm-tag :color="'#ff6743'" :text="'2016年'"></lxm-tag>
      </div>

      <template v-for="item in items">
        <lxm-contact-item :avatar="item.avatar"
                          :name="item.name"
                          :phone="item.phone"
                          :id="item.id"
                          :isFemale="item.isFemale"></lxm-contact-item>
      </template>
      <lxm-more v-if="hasMore" :loading="loading" @click="moreClicked"></lxm-more>
    </div>

    <!--<lxm-bottom-tabs></lxm-bottom-tabs>-->
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/variables.styl'
  .lxm-contact-tag__tag
    margin-bottom: spacing-small
</style>

<script>
  import LxmNav from '../common/LxmNav.vue'
  import LxmTag from '../common/LxmTag.vue'
  import LxmContactItem from '../common/LxmContactItem.vue'
  import LxmMore from '../common/LxmMore.vue'
  import LxmBottomTabs from '../common/LxmBottomTabs.vue'
  import * as aTypes from '../../../store/action-types'
  import * as mTypes from '../../../store/mutation-types'
  export default {
    components: {
      LxmNav,
      LxmTag,
      LxmContactItem,
      LxmMore,
      LxmBottomTabs
    },
    mounted () {
      this.$store.commit(mTypes.SET_NAV_TITLE, '')
      // 如需只加载一次 判断 this.$store.state.loading[aTypes.XXXX]
      // 为了切换用户刷新 不进行判断
      this.$store.dispatch(aTypes.CONTACT_GET_TAGGED_LIST, {
        append: false
      })
    },
    computed: {
      loading () {
        return this.$store.state.loading[aTypes.CONTACT_GET_TAGGED_LIST]
      },
      items () {
        return this.$store.state.contact.tag.list
      },
      hasMore () {
        return true
      }
    },
    methods: {
      moreClicked () {
        this.$store.dispatch(aTypes.CONTACT_GET_TAGGED_LIST, {
          append: true
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Tag.vue?37ef9a5d